module.exports = __webpack_public_path__ + "static/feature-recap-02-4b0ac7d638b66664c73b165dd4b890be.svg";